import { createSlice, PayloadAction, current } from "@reduxjs/toolkit";

// User data types
interface Props {
  menu: any;
  menu_permission: any;
  email: string;
  id: number;
  name: string;
  refresh: string;
  access: string;
  defaultCompany: string;
  profile_image: string;
  defaultCompnayId: string;
  defaultCompanyPayrunStartDate: string;
  actualDefaultCompanyId: string;
  lastLoggedInTime: any;
  lastActivityTime: any;
  isSessionActive: boolean;
  groups: any;
  permission: any;
  current_payrun_date: any;
  filing_date: any;
  employee_id: any;
  is_superuser: any;
  payslip_settings: any;
  isEmployee: boolean;
}

// initial state of user's data
const initialState: Props = {
  email: "",
  id: -1,
  name: "",
  refresh: "",
  profile_image: "",
  access: "",
  defaultCompany: "",
  defaultCompnayId: "",
  defaultCompanyPayrunStartDate: "",
  actualDefaultCompanyId: "",
  lastLoggedInTime: null,
  lastActivityTime: null,
  isSessionActive: false,
  menu: [],
  menu_permission: [],
  groups: [],
  permission: "full",
  current_payrun_date: "",
  filing_date: "",
  employee_id: null,
  is_superuser: null,
  payslip_settings: {
    include_employment_date: false,
    include_job_title: false,
    include_nric_fin: false,
  },
  isEmployee: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // reset the state
    resetUser: () => initialState,
    // update intial state of user data
    updateUserIntialState: (state: Props, action: PayloadAction<any>) => {
      current(state);
      state = Object.assign(state, action.payload);
    },
  },
});

export const { updateUserIntialState, resetUser } = userSlice.actions;
export default userSlice.reducer;
